import { useState, useEffect } from 'react'
import { useFetch } from './useFetch'

const useItemsHook = (url) => {
  const [items, setItems] = useState([])
  const [spinner, getItems] = useFetch()

  useEffect(() => {
    const fetchItems = async () => {
      const response = await getItems(url)
      setItems(response)
    }
    fetchItems()
  }, [url])

  return [{ items, spinner }]
}
export default useItemsHook
